import '../sass/image-and-text-cards.scss';
